var o = /* @__PURE__ */ ((t) => (t.Dictionary = "dictionary", t.Constellation = "constellation", t))(o || {});
const n = "::";
export {
  n as MetadataSeparator,
  o as MetadataType
};
//# sourceMappingURL=metadata.js.map
